var _mask, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThaGs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    masktype: "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 4,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V24H40V0Z",
    fill: "#A51931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3.9996H0V19.9996H40V3.9996Z",
    fill: "#F4F5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.0004H0V16.0004H40V8.0004Z",
    fill: "#2D2A4A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "saturation"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3101 24H0.689685C0.308827 24 0 23.7172 0 23.3684V0.631607C0 0.282821 0.308827 0 0.689685 0H39.3102C39.6911 0 39.9999 0.282821 39.9999 0.631607V23.3684C39.9998 23.7173 39.691 24 39.3101 24Z",
    fill: "#505050"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThaGs);
export default __webpack_public_path__ + "static/media/THA-gs.9649a5aa44bb1c13b6d16b26c3523e3a.svg";
export { ForwardRef as ReactComponent };